var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { BLACK_700, Checkbox, Typography, isLastItem, isValidObject } from '@airtel/air-design-system';
import { useEffect, useMemo, useState } from 'react';
import { View } from 'react-native';
import { getCheckboxGroupWidgetStyles } from './CheckboxGroupWidgetStyles';
export var CheckboxGroupWidgetComponent = props => {
  var id = props.id,
    _props$title = props.title,
    title = _props$title === void 0 ? '' : _props$title,
    _props$data = props.data,
    data = _props$data === void 0 ? [] : _props$data,
    _props$style = props.style,
    style = _props$style === void 0 ? {} : _props$style,
    _props$direction = props.direction,
    direction = _props$direction === void 0 ? 'row' : _props$direction,
    checkedIdx = props.checkedIdx,
    onSelectionMeta = props.onSelectionMeta,
    onSelection = props.onSelection,
    onUserAction = props.onUserAction,
    onActionCtaPressMetaData = props.onActionCtaPressMetaData,
    onHyperlinkPressMetaData = props.onHyperlinkPressMetaData,
    onExpandCtaPressMetaData = props.onExpandCtaPressMetaData,
    restProps = __rest(props, ["id", "title", "data", "style", "direction", "checkedIdx", "onSelectionMeta", "onSelection", "onUserAction", "onActionCtaPressMetaData", "onHyperlinkPressMetaData", "onExpandCtaPressMetaData"]);
  var checkboxGroupWidgetStyles = getCheckboxGroupWidgetStyles(direction);
  var _useState = useState({}),
    checkedState = _useState[0],
    setCheckedState = _useState[1];
  useEffect(() => {
    if (typeof checkedIdx === 'number') {
      setCheckedState(prev => {
        return Object.assign(Object.assign({}, prev), {
          [checkedIdx]: true
        });
      });
    }
  }, [checkedIdx]);
  var onCheckBoxItemPress = (item, index) => {
    return data => {
      setCheckedState(prev => {
        var _a;
        var checked = (_a = !(prev === null || prev === void 0 ? void 0 : prev[index])) !== null && _a !== void 0 ? _a : true;
        if (typeof onSelection == 'function') {
          onSelection === null || onSelection === void 0 ? void 0 : onSelection(Object.assign(Object.assign(Object.assign({}, item), data), {
            checked
          }));
        }
        onSelectionMeta && (onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign({
          id
        }, onSelectionMeta), Object.assign(Object.assign(Object.assign({}, item), data), {
          checked,
          checkedState: Object.assign(Object.assign({}, prev), {
            [index]: checked
          })
        })));
        return Object.assign(Object.assign({}, prev), {
          [index]: checked
        });
      });
    };
  };
  var memoizedData = useMemo(() => {
    return data === null || data === void 0 ? void 0 : data.map(checkboxProps => {
      var _a;
      var updatedData = (_a = checkboxProps === null || checkboxProps === void 0 ? void 0 : checkboxProps.multiTextLabel) === null || _a === void 0 ? void 0 : _a.map(item => {
        if (isValidObject(onHyperlinkPressMetaData)) {
          return Object.assign(Object.assign({}, item), {
            onPress: data => {
              onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign({
                id
              }, onHyperlinkPressMetaData), {
                checkedState,
                data,
                item
              });
            }
          });
        }
        return item;
      });
      if (isValidObject(onExpandCtaPressMetaData)) {
        checkboxProps.expandCtaData.onExpandCtaPress = data => {
          onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign({
            id
          }, onExpandCtaPressMetaData), {
            checkedState,
            data
          });
        };
      }
      return Object.assign(Object.assign({}, checkboxProps), {
        multiTextLabel: updatedData
      });
    });
  }, [data, id, onHyperlinkPressMetaData, onExpandCtaPressMetaData, onUserAction, checkedState]);
  return _jsx(_Fragment, {
    children: !!(data === null || data === void 0 ? void 0 : data.length) && _jsxs(View, Object.assign({
      style: [checkboxGroupWidgetStyles.container, style]
    }, restProps, {
      children: [!!title && _jsx(Typography, {
        style: checkboxGroupWidgetStyles.title,
        text: title,
        type: "body-single-line-xs",
        color: BLACK_700
      }), _jsx(View, Object.assign({
        style: checkboxGroupWidgetStyles.checkboxButtons
      }, {
        children: memoizedData === null || memoizedData === void 0 ? void 0 : memoizedData.map((checkboxProps, index) => {
          return _jsx(View, Object.assign({
            style: checkboxGroupWidgetStyles.checkboxFlex
          }, {
            children: _jsx(Checkbox, Object.assign({
              style: [!isLastItem(data, index) && checkboxGroupWidgetStyles.checkbox]
            }, checkboxProps, {
              checked: checkedState === null || checkedState === void 0 ? void 0 : checkedState[index],
              onPress: onCheckBoxItemPress(checkboxProps, index),
              onActionCtaPress: () => onActionCtaPressMetaData && (onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign({
                id
              }, onActionCtaPressMetaData), {
                checkedState
              }))
            }), "air_checkbox_widget" + index)
          }), "checkbox-" + index);
        })
      }))]
    }))
  });
};
CheckboxGroupWidgetComponent.genericRendererKey = 'AirCheckboxGroupWidget';